import React from "react";
import "./style.scss";

interface IControl {
	hidden: boolean;
	top: number;
	bottom: number;
	left: number;
	right: number;
	children: any;

	trigger(): void;
}

export default function index(props: IControl) {
	return (
		<div onContextMenu={(e) => e.preventDefault()} onClick={props.trigger} hidden={props.hidden} className="ut-context-menu-overlay ut-card">
			<div
				className="ut-context-menu"
				style={
					props.left
						? props.bottom !== undefined
							? { bottom: props.bottom, left: props.left }
							: { top: props.top, left: props.left }
						: props.bottom !== undefined
						? { bottom: props.bottom, right: props.right }
						: { top: props.top, right: props.right }
				}
			>
				{props.children}
			</div>
		</div>
	);
}
